import AppIcon from '../icons/AppIcon'
import styles from './GateScreen.module.css'

interface GateSubmittedBannerProps {
  waitingCount: number
}

export default function GateSubmittedBanner({ waitingCount }: GateSubmittedBannerProps) {
  return (
    <div className={styles.doneCard}>
      <div className={styles.doneIcon}>
        <AppIcon icon="mdi:check" size={18} />
      </div>
      <div className={styles.doneText}>
        <strong className={styles.doneTitle}>You&apos;re in!</strong>
        <span className={styles.doneSub}>
          Nice moves. Waiting on {waitingCount} teammate{waitingCount === 1 ? '' : 's'} to clear
          the gate.
        </span>
      </div>
    </div>
  )
}
